import { postRequest } from '../clients/axios';
import { TourBagMstrPayload } from '../models';

export const postSaveTourBagMstrData = async (data: TourBagMstrPayload) => {
  const url = 'tourBag/SaveTourBagMstrData';
  const response = await postRequest(url, data);
  return response;
};
